import { TFunction } from 'react-i18next';

import statesAndCities from '@helpers/statesAndCities';

const YES = 'YES';
const NO = 'NO';
const genderOptions = [
  { label: 'option.gender.MALE', value: 'MALE' },
  { label: 'option.gender.FEMALE', value: 'FEMALE' },
  { label: 'option.gender.OTHER', value: 'OTHER' },
];
const dietCodes = ['omnivorous', 'flexitarian', 'rawFood', 'vegetarian', 'vegan', 'other'];
const interestCodes = ['sports', 'reading', 'cultural'];
const lifestyleCodes = [
  'health',
  'selfEducation',
  'environment',
  'aesthetics',
  'healthWithoutTime',
  'socialMedia',
  'qualityTime',
  'careerAndFamily',
  'closeFriends',
  'gardening',
];
interface BuildOptionTranslateParams {
  trans: TFunction<string>;
  source: string;
  list: string[];
}

const buildOptionTranslate = ({ trans, source, list }: BuildOptionTranslateParams) => {
  return list.map((code) => {
    const transKey = `option.${source}.${code}`;
    return { label: trans(transKey), value: code };
  });
};
const preferenceOptions = [{ id: 'alcohol', title: 'Alcohol' }];

const numberOfHomeComponentsOptions = [
  { label: '1 persona', value: '1' },
  { label: '2 personas', value: '2' },
  { label: '3 personas', value: '3' },
  { label: '4 personas', value: '4' },
  { label: '5 personas', value: '5' },
  { label: '6 personas', value: '6' },
  { label: 'Más de 6 personas', value: '+6' },
];
const numberOfChildsComponentsOptions = [
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

const partnerOptions = [
  { label: 'Sí', value: 'YES' },
  { label: 'No', value: 'NO' },
];
const educationOptions = [
  { value: '0', label: 'Level 0: Pre-primary education' },
  { value: '1', label: 'Level 1: Primary education or first stage of basic education' },
  { value: '2', label: 'Level 2: Lower secondary education or second stage of basic education' },
  { value: '3', label: 'Level 3: Upper secondary education' },
  { value: '4', label: 'Level 4: Post-secondary non-tertiary education' },
  { value: '5', label: 'Level 5: Short-cycle tertiary education' },
  { value: '6', label: "Level 6: Bachelor's or equivalent" },
  { value: '7', label: "Level 7: Master's or equivalent" },
  { value: '8', label: 'Level 8: Doctoral or equivalent' },
];

const petsOptions = [
  { id: 'DOG', title: 'Perro' },
  { id: 'CAT', title: 'Gato' },
  { id: 'BIRD', title: 'Pájaro' },
  { id: 'MOUSE', title: 'Roedor' },
  { id: 'FISH', title: 'Pez' },
  { id: 'OTHER', title: 'Otro' },
];

const telephonePoliciesOptions = [
  {
    code: 'telephoneSazCommunications',
    name: 'SAZ telephone communications',
  },
  {
    code: 'telephoneOthersCommunications',
    name: 'Walmart Aurrera telehone communications',
  },
];

const buildStateOptions = () => {
  const stateRaw: any = Object.keys(statesAndCities());
  const response: any = [];

  stateRaw.forEach((item: any) => {
    response.push({
      label: item,
      value: item,
    });
  });

  return response;
};
const buildCityOptions = (state: any) => {
  const stateRaw: any = statesAndCities();
  const response: any = [];
  if (state !== undefined) {
    if (stateRaw[state]) {
      stateRaw[state].forEach((item: any) => {
        response.push({
          label: item,
          value: item,
        });
      });
    }
    return response;
  }

  return response;
};
const translateOptions = (options: any, t: any) => {
  return options.map((option: any) => {
    return {
      label: t(option.label),
      value: option.value,
    };
  });
};

const radioYes = {
  value: YES,
  label: 'Sí',
};
const radioNo = {
  value: NO,
  label: 'No',
};
const radioHasAllergies = [radioYes, radioNo];
const allergiesCheckValues = [
  {
    label: 'forms.profile.allergiesOptions.milk',
    value: 'milk',
  },
  {
    label: 'forms.profile.allergiesOptions.crustaceans',
    value: 'crustaceans',
  },
  {
    label: 'forms.profile.allergiesOptions.eggs',
    value: 'eggs',
  },
  {
    label: 'forms.profile.allergiesOptions.treeNuts',
    value: 'treeNuts',
  },
  {
    label: 'forms.profile.allergiesOptions.gluten',
    value: 'gluten',
  },
  {
    label: 'forms.profile.allergiesOptions.fish',
    value: 'fish',
  },
  {
    label: 'forms.profile.allergiesOptions.peanuts',
    value: 'peanuts',
  },
  {
    label: 'forms.profile.allergiesOptions.soybeans',
    value: 'soybeans',
  },
  {
    label: 'forms.profile.allergiesOptions.celery',
    value: 'celery',
  },
  {
    label: 'forms.profile.allergiesOptions.mustard',
    value: 'mustard',
  },

  {
    label: 'forms.profile.allergiesOptions.sesameSeeds',
    value: 'sesameSeeds',
  },
  {
    label: 'forms.profile.allergiesOptions.sulfurDioxideAndSulfites',
    value: 'sulfurDioxideAndSulfites',
  },
  {
    label: 'forms.profile.allergiesOptions.lupine',
    value: 'lupine',
  },
  {
    label: 'forms.profile.allergiesOptions.molluscs',
    value: 'molluscs',
  },
];

export {
  genderOptions,
  numberOfHomeComponentsOptions,
  partnerOptions,
  buildCityOptions,
  buildStateOptions,
  educationOptions,
  preferenceOptions,
  translateOptions,
  telephonePoliciesOptions,
  radioYes,
  radioNo,
  numberOfChildsComponentsOptions,
  petsOptions,
  buildOptionTranslate,
  dietCodes,
  interestCodes,
  lifestyleCodes,
  allergiesCheckValues,
  radioHasAllergies,
};
